import { render, staticRenderFns } from "./decimal.vue?vue&type=template&id=a6a836ae"
import script from "./decimal.ts?vue&type=script&lang=js&external"
export * from "./decimal.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6a836ae')) {
      api.createRecord('a6a836ae', component.options)
    } else {
      api.reload('a6a836ae', component.options)
    }
    module.hot.accept("./decimal.vue?vue&type=template&id=a6a836ae", function () {
      api.rerender('a6a836ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/decimal.vue"
export default component.exports